"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerExpressPaths = exports.getBorrowerExpressUrl = exports.getAdminExpressUrl = exports.getSlackConfigUrl = exports.getSlackInstallUrl = exports.getPlaidWebhookUrl = exports.getAdminReportUploadUrl = exports.getAdminReportTemplateUploadUrl = exports.getAuth0ClientId = exports.getAuth0ApiUrl = exports.getAuth0DomainUrl = exports.getAuth0CallbackUrl = exports.getAuth0Domain = exports.getAdminGraphqlapiUrl = exports.getApiUrl = exports.getGraphqlapiUrl = exports.getAdminGraphqlapiHostname = exports.getGraphqlapiHostname = exports.getCustomerDashboardUrl = exports.getAdminDashboardUrl = exports.getAdminDashboardHostname = exports.getApiGatewayHostname = exports.getAwsAccountId = void 0;
const assert_1 = __importDefault(require("assert"));
const lodash_1 = __importDefault(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const utils_1 = __importDefault(require("./utils"));
/**
 * NOTE: Please use following standard naming convention based on rfc3986
 * https://datatracker.ietf.org/doc/html/rfc3986
 *
 * Given following url:
 * https://app.finleycms.com/path/to/api?query=something#panda
 * https://app.stage.finleycms.com/path/to/api
 *
 * protocol/scheme: https
 * subdomain: app(or app.stage)
 * SLD (second-level domain): finleycms
 * TLD (top-level domain): com
 * path: /path/to/api
 * query: query=something
 * fragment: panda
 * hostname/fqdn/authority: app.finleycms.com (combination of subdomain + SLD + TLD)
 * url: https://app.finleycms.com/path/to/api (combination of protocol, hostname, path)
 *
 * Finally, for internal const nameing:
 * prl - protocol-relative link (or protocol-relative URL) is a URL without specific scheme/protocol
 * ie) //app.finlycms.com/path/to/api
 */
const awsAccountIds = {
    development: '890870160103',
    stage: '890870160103',
    prod: '037351467533',
};
// TODO: app.finleycms.com are sprawling across our codebase also.  We need to consolidate this.
const apiGatewayHostnameForEnv = {
    test: 'localhost:9000',
    development: 'localhost:9000',
    stage: 'api.stage.finleycms.com',
    prod: 'api.finleycms.com',
};
const graphqlHostnameForEnv = {
    test: 'localhost:8000',
    development: 'localhost:8000',
    stage: 'app.stage.finleycms.com',
    prod: 'app.finleycms.com',
};
const graphqlAdminHostnameForEnv = {
    test: 'localhost:8001',
    development: 'localhost:8001',
    stage: 'admin.stage.finleycms.com',
    prod: 'admin.finleycms.com',
};
const customerDashboardHostname = {
    test: 'localhost:4000',
    development: 'localhost:4000',
    stage: 'app.stage.finleycms.com',
    prod: 'app.finleycms.com',
};
const adminDashboardHostname = {
    test: 'localhost:4001',
    development: 'localhost:4001',
    stage: 'admin.stage.finleycms.com',
    prod: 'admin.finleycms.com',
};
const auth0Domain = {
    test: 'dev-627joikrtvrw47zk.us.auth0.com',
    development: 'dev-627joikrtvrw47zk.us.auth0.com',
    stage: 'dev-627joikrtvrw47zk.us.auth0.com',
    prod: 'finleycms-prod-dashboard.us.auth0.com',
};
const auth0ClientId = {
    test: 'dNMUEyKnMMF853m5rYlIO3ZKI41jIEhw',
    development: 'dNMUEyKnMMF853m5rYlIO3ZKI41jIEhw',
    stage: 'dNMUEyKnMMF853m5rYlIO3ZKI41jIEhw',
    prod: 'D29x0lAlDRUI85Yf33lWrsPpUzLpyioj',
};
/**
 * Prepend appropriate HTTP(s) protocol scheme for the environment
 */
const withHttpProtocol = (prl, env) => {
    const protocol = env === 'development' ? 'http' : 'https';
    return `${protocol}:${prl}`;
};
/**
 * get apigateway hostname
 */
const getApiGatewayHostnameByEnv = (env) => {
    const hostname = lodash_1.default.get(apiGatewayHostnameForEnv, env);
    (0, assert_1.default)(hostname, `apigateway hostname for [${env}] does not exist`);
    return hostname;
};
/**
 * getAdminDashboardHostname
 */
const getAdminDashboardHostnameByEnv = (env) => {
    const hostname = lodash_1.default.get(adminDashboardHostname, env);
    (0, assert_1.default)(hostname, `admin dashboard hostname for [${env}] does not exist`);
    return hostname;
};
/**
 * getCustomerDashboardHostname
 */
const getCustomerDashboardHostnameByEnv = (env) => {
    const hostname = lodash_1.default.get(customerDashboardHostname, env);
    (0, assert_1.default)(hostname, `customer dashboard hostname for [${env}] does not exist`);
    return hostname;
};
/**
 * Simple map look-up for now, since we don't have any clustering
 */
const getGraphqlapiHostnameByEnv = (env) => {
    const hostname = lodash_1.default.get(graphqlHostnameForEnv, env);
    (0, assert_1.default)(hostname, `graphqlapi hostname for [${env}] does not exist`);
    return hostname;
};
const getAdminGraphqlapiHostnameByEnv = (env) => {
    const hostname = lodash_1.default.get(graphqlAdminHostnameForEnv, env);
    (0, assert_1.default)(hostname, `graphqlapi hostname for [${env}] does not exist`);
    return hostname;
};
const getAuth0DomainByEnv = (env) => {
    const domain = lodash_1.default.get(auth0Domain, env);
    (0, assert_1.default)(domain, `auth0 domain for [${env}] does not exist`);
    return domain;
};
const getAuth0ClientIdByEnv = (env) => {
    const clientId = lodash_1.default.get(auth0ClientId, env);
    (0, assert_1.default)(clientId, `auth0 domain for [${env}] does not exist`);
    return clientId;
};
// ========== Public methods ==========
/**
 * gets aws account id
 */
const getAwsAccountId = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    return awsAccountIds[env];
};
exports.getAwsAccountId = getAwsAccountId;
const getApiGatewayHostname = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    return getApiGatewayHostnameByEnv(env);
};
exports.getApiGatewayHostname = getApiGatewayHostname;
const getAdminDashboardHostname = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    return getAdminDashboardHostnameByEnv(env);
};
exports.getAdminDashboardHostname = getAdminDashboardHostname;
const getAdminDashboardUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const prl = `//${getAdminDashboardHostnameByEnv(env)}`;
    return withHttpProtocol(prl, env);
};
exports.getAdminDashboardUrl = getAdminDashboardUrl;
const getCustomerDashboardUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const prl = `//${getCustomerDashboardHostnameByEnv(env)}`;
    return withHttpProtocol(prl, env);
};
exports.getCustomerDashboardUrl = getCustomerDashboardUrl;
const getGraphqlapiHostname = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    return getGraphqlapiHostnameByEnv(env);
};
exports.getGraphqlapiHostname = getGraphqlapiHostname;
const getAdminGraphqlapiHostname = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    return getAdminGraphqlapiHostnameByEnv(env);
};
exports.getAdminGraphqlapiHostname = getAdminGraphqlapiHostname;
const getGraphqlapiUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/graphql`;
    return withHttpProtocol(prl, env);
};
exports.getGraphqlapiUrl = getGraphqlapiUrl;
const getApiUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}`;
    return withHttpProtocol(prl, env);
};
exports.getApiUrl = getApiUrl;
const getAdminGraphqlapiUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = getAdminGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/graphql`;
    return withHttpProtocol(prl, env);
};
exports.getAdminGraphqlapiUrl = getAdminGraphqlapiUrl;
const getAuth0Domain = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    return getAuth0DomainByEnv(env);
};
exports.getAuth0Domain = getAuth0Domain;
const getAuth0CallbackUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = (0, exports.getGraphqlapiHostname)();
    const prl = `//${hostname}/auth0`;
    return withHttpProtocol(prl, env);
};
exports.getAuth0CallbackUrl = getAuth0CallbackUrl;
const getAuth0DomainUrl = () => {
    const hostname = (0, exports.getAuth0Domain)();
    // always https
    return `https://${hostname}`;
};
exports.getAuth0DomainUrl = getAuth0DomainUrl;
const getAuth0ApiUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = getAuth0DomainByEnv(env);
    return `https://${hostname}/api/v2`;
};
exports.getAuth0ApiUrl = getAuth0ApiUrl;
const getAuth0ClientId = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    return getAuth0ClientIdByEnv(env);
};
exports.getAuth0ClientId = getAuth0ClientId;
// generates static admin api route base url to upload report-templates
const getAdminReportTemplateUploadUrl = (reportType) => {
    const env = utils_1.default.EnvUtils.getEnv();
    const endpoint = lodash_1.default.includes(lodash_1.default.values(finley_types_1.Report.DocxReportTemplateType), reportType)
        ? 'docx'
        : lodash_1.default.kebabCase(reportType);
    const hostname = getAdminGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/report-templates/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getAdminReportTemplateUploadUrl = getAdminReportTemplateUploadUrl;
const getAdminReportUploadUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const endpoint = 'reports';
    const hostname = getAdminGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getAdminReportUploadUrl = getAdminReportUploadUrl;
const getPlaidWebhookUrl = () => {
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/plaid/services/webhook`;
    return withHttpProtocol(prl, env);
};
exports.getPlaidWebhookUrl = getPlaidWebhookUrl;
const getSlackInstallUrl = (borrowerId) => {
    // Use stage env hostname for development env
    const env = utils_1.default.EnvUtils.isDevelopment()
        ? 'stage'
        : utils_1.default.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/slack/install?borrowerId=${borrowerId}`;
    return withHttpProtocol(prl, env);
};
exports.getSlackInstallUrl = getSlackInstallUrl;
const getSlackConfigUrl = () => {
    // Use stage env hostname for development env
    const env = utils_1.default.EnvUtils.isDevelopment()
        ? 'stage'
        : utils_1.default.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}`;
    return withHttpProtocol(prl, env);
};
exports.getSlackConfigUrl = getSlackConfigUrl;
const getAdminExpressUrl = (endpoint) => {
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = getAdminGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getAdminExpressUrl = getAdminExpressUrl;
const getBorrowerExpressUrl = (endpoint) => {
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getBorrowerExpressUrl = getBorrowerExpressUrl;
var borrowerExpressPaths;
(function (borrowerExpressPaths) {
    borrowerExpressPaths["cashBalanceFormUpload"] = "manual-datatape-upload/cash-balance-form";
    borrowerExpressPaths["dataTapeUploadCapitalProvider"] = "manual-datatape-upload/data-tape-capital-provider";
    borrowerExpressPaths["assignByCSVPreviewGenAndCSVUpload"] = "assignment/assign-by-csv/preview-gen-file-upload";
    borrowerExpressPaths["auth0Login"] = "auth0-login";
    borrowerExpressPaths["assignByCSVValidation"] = "assignment/assign-by-csv/file-structure-validation";
})(borrowerExpressPaths = exports.borrowerExpressPaths || (exports.borrowerExpressPaths = {}));
const getCashBalanceFormUploadUrl = ({ admin }) => {
    const endpoint = borrowerExpressPaths.cashBalanceFormUpload;
    const env = utils_1.default.EnvUtils.getEnv();
    const hostname = admin
        ? getAdminGraphqlapiHostnameByEnv(env)
        : getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.default = {
    getAwsAccountId: exports.getAwsAccountId,
    getApiGatewayHostname: exports.getApiGatewayHostname,
    getAdminDashboardHostname: exports.getAdminDashboardHostname,
    getCustomerDashboardUrl: exports.getCustomerDashboardUrl,
    getGraphqlapiHostname: exports.getGraphqlapiHostname,
    getGraphqlapiUrl: exports.getGraphqlapiUrl,
    getAdminDashboardUrl: exports.getAdminDashboardUrl,
    getAdminGraphqlapiHostname: exports.getAdminGraphqlapiHostname,
    getAdminGraphqlapiUrl: exports.getAdminGraphqlapiUrl,
    getAdminReportUploadUrl: exports.getAdminReportUploadUrl,
    getAdminReportTemplateUploadUrl: exports.getAdminReportTemplateUploadUrl,
    getPlaidWebhookUrl: exports.getPlaidWebhookUrl,
    getApiUrl: exports.getApiUrl,
    getSlackConfigUrl: exports.getSlackConfigUrl,
    getSlackInstallUrl: exports.getSlackInstallUrl,
    getAdminExpressUrl: exports.getAdminExpressUrl,
    getAuth0CallbackUrl: exports.getAuth0CallbackUrl,
    getAuth0Domain: exports.getAuth0Domain,
    getAuth0DomainUrl: exports.getAuth0DomainUrl,
    getAuth0ClientId: exports.getAuth0ClientId,
    getAuth0ApiUrl: exports.getAuth0ApiUrl,
    getBorrowerExpressUrl: exports.getBorrowerExpressUrl,
    getCashBalanceFormUploadUrl,
    borrowerExpressPaths,
};
//# sourceMappingURL=url.js.map